<script setup>
import notification from "@/utils/plugins/NotificationService";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import { ref, computed, onMounted } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";

import { useRoute } from "vue-router";
/* import moment from "moment"; */
//Components
import CourseSessionForm from "@/components/shared/Training/CourseSessionForm.vue";
// Services
import CourseServices from "@/api/services/course.service";
import ProviderService from '@/api/services/provider.service';
import courseSessionService from "@/api/services/courseSession.service";


const route = useRoute();

const dialogCourseSession = ref(false);
const selectedSession = ref();
const deleteDialogShown = ref(false)

const props = defineProps({
    course: Object,
    update: Boolean
})
const authStore = useAuthStore();
const uiStore = useUiStore();

const isNew = computed(() => {
    if (course2.value) {
        return false;
    } else {
        return true;
    }
})

const name = ref(null);
const courseProvider = ref(null);
const providers = ref([]);
const course_modality = ref(null);
const optionsStatus = ref([
    { name: "Online", value: "online" },
    { name: "Presencial", value: "presential" },
    { name: "Hibrido", value: "hybrid" },

]);
const course_cost = ref();
const description = ref(null);
const observations = ref(null);
const courseUrl = ref('')
const isEdit = ref(false);
const isLoading = ref(false);

const sessions = computed(() => {
    if (course2.value && course2.value.courseSessions) {
        return course2.value.courseSessions;
    }
    return []
})

// eslint-disable-next-line no-unused-vars
const course2 = ref(null);


// eslint-disable-next-line no-unused-vars
const selectedCourse = computed(() => {
    if (props && props.course) {
        return props.course
    }
    return null;
})

const isAdmin = computed(() => {
    const user = authStore.getUserLogged;
    return user.roles.includes('ROLE_ADMIN');
});
const course_hours = ref();

onMounted(() => {
    if (route.params && route.params.id) {
        getCourse(route.params.id);
    }
    getProviders();
})

const createCourse = async () => {
    if (!name.value) {
        notification.addNotification({
            title: 'Error',
            message: 'El campo nombre no debe ser vacío.',
            type: 'error'
        });
        return;
    } else if (!description.value) {
        notification.addNotification({
            title: 'Error',
            message: 'El campo descripción no debe ser vacío.',
            type: 'error'
        });
        return;

    } else if (!course_modality.value) {
        notification.addNotification({
            title: 'Error',
            message: 'El campo estado no debe ser vacío.',
            type: 'error'
        });
        return;
    }
    const item = {
        name: name.value,
        description: description.value,
        durationHours: course_hours.value.toString(),
        modality: course_modality.value,
        provider: courseProvider.value,
        cost: numberToStringTwoDecimals(course_cost.value),
        observations: observations.value
    }
    if (course_modality.value === 'online') {
        item.url = courseUrl.value;
    }

    await uiStore.stopLoading();
    isLoading.value = true;
    if (!isNew.value) {
        CourseServices.updateCourse(course2.value.id, item)
            .then((res) => {
                if (res && res.status && (res.status === 200 || res.status === 201)) {
                    notification.addNotification({
                        title: 'Curso actualizado',
                        message: 'El curso ha sido actualizado correctamente',
                        type: 'success'
                    });
                    goBack();
                }else{
                    isLoading.value = false;
                }
            }).catch((error) => {
                notification.addNotification({
                    title: 'Error',
                    message: 'Error al actualizar el curso',
                    type: 'error'
                });
                console.log("Error:", error);
            }).finally(async () => {
                await uiStore.stopLoading();
            }
            );
    } else {
        CourseServices.createCourse(item)
            .then((res) => {
                if (res && res.status && (res.status === 200 || res.status === 201)) {
                    notification.addNotification({
                        title: 'Curso creado',
                        message: 'El curso ha sido creado correctamente',
                        type: 'success'
                    });
                    goBack();
                }
            }).catch((error) => {
                notification.addNotification({
                    title: 'Error',
                    message: 'Error al crear el curso',
                    type: 'error'
                });
                console.log("Error:", error);
            }).finally(async () => {
                await uiStore.stopLoading();
                isLoading.value = false;
            });
    }

}

const checkIfNumber = (value) => {
    if (typeof value === 'number' && !Number.isNaN(value)) {
        return value;
    }
    if (typeof value === 'string') {
        const num = Number(value);
        if (!Number.isNaN(num)) {
            return num;
        }
    }
    return null;
}

const getCourse = (id) => {
    if (!id) {
        return;
    }
    uiStore.startLoading();
    const params = {}
    CourseServices.getCourse(id, params)
        .then((res) => {
            course2.value = res.data;
            name.value = course2.value.name;
            description.value = course2.value.description;
            observations.value = course2.value.observations;
            course_hours.value = checkIfNumber(course2.value.durationHours);
            course_cost.value = checkIfNumber(course2.value.cost);
            course_modality.value = course2.value.modality;
            courseProvider.value = course2.value.provider;
            courseUrl.value = course2.value.url;
            uiStore.stopLoading();
        })
}

const goBack = () => {
    history.back();
}

const getProviders = () => {
    const params = {
        type: "training",
    }

    ProviderService.getProviders(params).then((res) => {
        providers.value = res.data['hydra:member'];
    })
}

function numberToStringTwoDecimals(value) {
    if (value === null || value === undefined) {
        return '';
    }

    const num = Number(value);
    if (isNaN(num)) {
        return '';
    }
    return num.toFixed(2);
}

const getStatus = (status) => {
    switch (status) {
        case "published":
            return "Publicado";
        case "planned":
            return "Planificado";
        case "ongoing":
            return "En curso";
        case "finished":
            return "Finalizado";
        case "canceled":
            return "Cancelado";
        case "disabled":
            return "Deshabilitado";
        default:
            return "Otro";
    }
}

const closeDialogSessionForm = () => {
    dialogCourseSession.value = false;
    selectedSession.value = null;
    getCourse(route.params.id);
}
const openDialogSessionForm = (session) => {
    selectedSession.value = session;
    dialogCourseSession.value = true;
}

const formatDate = (input) => {
    const date = new Date(input);
    if (isNaN(date.getTime())) {
        return ''; // o devuelve algo por defecto si la fecha no es válida
    }

    const pad = (n) => String(n).padStart(2, '0');

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const mins = pad(date.getMinutes());

    return `${day}-${month}-${year} ${hours}:${mins}`;
}

const deleteSelectedSession = (selected) => {
    if (!selected) {
        notification.addNotification({
            type: 'error',
            message: 'Ha ocurrido un error al eliminar la convocatoria',
            duration: 6000
        })
        deleteDialogShown.value = false;
        return;
    }
    courseSessionService.discardCourseSession(selected.id).then((res) => {
        if (res && res.status === 204) {
            notification.addNotification({
                type: 'success',
                message: 'Convocatoria eliminada correctamente',
                duration: 6000
            })
        }
        getCourse(route.params.id);
        deleteDialogShown.value = false;

    })
}

</script>

<template>
    <div>
        <header-title title="Talento" />
        <div class="d-flex flex-row justify-content-start">
            <img src="@/assets/icons/graduating-hat-blue.svg" width="50" alt="">
            <div class="title-text ml-4">
                Curso
            </div>
        </div>

        <div class="row courseFormRow">
            <div class="col-md-8">
                <div class="d-flex flex-column flex-nowrap mt-4 w-100 label-common">
                    <div class="form-item">
                        <label for="title">Nombre del curso</label>
                        <el-input id="title" v-model="name" placeholder="Ingrese el nombre" />
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="d-flex flex-column flex-nowrap mt-4 w-100 label-common">
                    <div class="form-item date-picker">
                        <label for="id-provider" class="w-100">Proveedor</label>
                        <el-select id="id-provider" v-model="courseProvider" filterable clearable placeholder="TODOS"
                            :disabled="!isAdmin">
                            <el-option v-for="item in providers" :key="item.id" :label="item.legalName"
                                :value="item['@id']" />
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row courseFormRow">
            <div class="col-md-4 d-flex flex-nowrap flex-column mt-4 label-common">
                <div class="form-item date-picker">
                    <label for="course_hours" class="">Duración (en horas)</label>
                    <el-input-number id="course_hours" v-model="course_hours" class="search-input" style="width: 100%;"
                        :min="0" :max="1000000" placeholder="Indique los minutos con número. Ej: 120"
                        :controls="false" />
                </div>
            </div>
            <div class="col-md-4 d-flex flex-nowrap flex-column mt-4 label-common">
                <div class="form-item date-picker">
                    <label for="course_cost" class="">Coste (en €)</label>
                    <el-input-number id="course_cost" v-model="course_cost" class="search-input" style="width: 100%;"
                        :precision="2" :min="0" :max="1000000" placeholder="Indique el coste con número. Ej: 138,23"
                        :controls="false" />
                </div>
            </div>
            <div class="col-md-4 d-flex flex-nowrap flex-column mt-4 label-common">
                <div class="form-item">
                    <label for="id-modality" class="w-100">Modalidad</label>
                    <div>
                        <el-select id="id-modality" v-model="course_modality" filterable clearable :readonly="!isEdit"
                            placeholder="TODOS" :disabled="!isAdmin">
                            <el-option v-for="item in optionsStatus" :key="item.id" :label="item.name"
                                :value="item.value" />
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 courseFormRow" v-if="course_modality === 'online'">
            <div class="d-flex flex-column flex-nowrap mt-4 w-100 label-common">
                <div class="form-item">
                    <label for="url">Url del curso</label>
                    <el-input id="url" v-model="courseUrl" placeholder="Ingrese el nombre" />
                </div>
            </div>
        </div>
        <div class="row ml-1 mt-5 label-common">
            <div class="form-item">
                <label class="w-100" for="description">Descripci&oacute;n</label>
                <textarea v-model="description" id="description" class="w-100 p-3 font18" rows="4" />
            </div>
        </div>
        <div class="row ml-1 label-common">
            <div class="form-item">
                <label class="w-100" for="observations">Anotaciones</label>
                <textarea v-model="observations" id="observations" class="w-100 p-3 font18" rows="4" />
            </div>
        </div>
        <div v-if="!isNew" class="courseSessionButton">
            <button class="btn btn_yellow btn-search ml-4" @click="openDialogSessionForm()" :disabled="isLoading"
                style="width: 22em;">
                AÑADIR CONVOCATORIA
            </button>
        </div>
        <!-- Tabla convocatorias ordenador -->
        <div v-if="!isNew && course2 && course2.courseSessions && course2.courseSessions.length > 0"
            class="table-not-mobile">
            <div class="table">
                <div v-if="sessions && sessions.length > 0">
                    <table>
                        <thead>
                            <tr>
                                <th>Fecha inicio</th>
                                <th>Fecha fin</th>
                                <th>Aforo</th>
                                <th>Localización</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="session in sessions" :key="session.id">
                                <td>
                                    {{ formatDate(session.startAt) }}
                                </td>

                                <td>
                                    {{ formatDate(session.endAt) }}
                                </td>
                                <td>
                                    {{ session.capacity }}
                                </td>
                                <td>
                                    {{ session.location }}
                                </td>
                                <td>
                                    {{ getStatus(session.status) }}
                                </td>
                                <td>
                                    <span :class="session.status ? 'status-active' : 'status-inactive'">
                                        {{ session.status ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </td>
                                <td>
                                    <div class="buttons d-inline-flex">
                                        <div class="pointer">
                                            <font-awesome-layers class="fa-2x" style="margin-left: 5px" title="Editar"
                                                @click="openDialogSessionForm(session)">
                                                <font-awesome-icon icon="circle" style="color: #f7d20e" />
                                                <font-awesome-icon icon="plus" class="fa-inverse"
                                                    transform="shrink-6" />
                                            </font-awesome-layers>
                                        </div>
                                        <div class="pointer"
                                            @click="deleteDialogShown = true; selectedSession = session;">
                                            <font-awesome-layers class="fa-2x" style="margin-left: 5px"
                                                title="Dar de baja"
                                                @click="deleteDialogShown = true; selectedSession = session;">
                                                <font-awesome-icon icon="circle" style="color:red" />
                                                <font-awesome-icon icon="times" class="fa-inverse"
                                                    transform="shrink-6" />
                                            </font-awesome-layers>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Tabla convocatorias móvil -->
        <div v-if="!isNew && course2 && course2.courseSessions && course2.courseSessions.length > 0"
            class="table-mobile mb-4 mt-1">
            <div v-if="sessions && sessions.length > 0">
                <div v-for="session in sessions" :key="session.id">
                    <el-row class="mt-3">
                        <el-card class="card-session-item">
                            <div class="session-mobile-card__delete">
                                <font-awesome-layers class="fa-2x pointer" title="Dar de baja"
                                    @click.stop="deleteDialogShown = true; selectedSession = session;">
                                    <font-awesome-icon icon="circle" style="color:red" />
                                    <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                                </font-awesome-layers>
                            </div>
                            <div class="row d-flex pointer" @click="openDialogSessionForm(session)">
                                <div class="el-col-xs-24">
                                    <span class="session-item-span">Inicio: </span> {{ formatDate(session.startAt) }}
                                </div>
                                <div class="el-col-xs-24">
                                    <span class="session-item-span">Fin: </span>{{ formatDate(session.endAt) }}
                                </div>
                                <div class="el-col-xs-24" v-if="session && session.capacity">
                                    <span class="session-item-span">Aforo: </span> {{ session.capacity }}
                                </div>
                                <div class="el-col-xs-24" v-if="session && session.location">
                                    <span class="session-item-span">Localización: </span>{{ session.location }}
                                </div>
                                <div class="el-col-xs-15 mt-1" v-if="session && session.status">
                                    <span class="session-item-span">Estado: </span>{{ getStatus(session.status) }}
                                </div>
                                <div class="el-col-xs-7 mb-2" v-if="session && session.status">
                                    <span :class="session.status ? 'status-active' : 'status-inactive'">
                                        {{ session.status ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </div>
                            </div>
                        </el-card>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
            <button class="btn btn_yellow btn-search " @click="goBack()">
                VOLVER
            </button>
            <button class="btn btn_red btn-search ml-4" @click="createCourse()" :disabled="isLoading">
                {{ isNew ? 'CREAR' : 'GUARDAR' }}
            </button>
        </div>
    </div>

    <el-dialog v-model="dialogCourseSession" width="600" :show-close="false" :lock-scroll="true"
        style="border-radius: 20px;" @close="closeDialogSessionForm">
        <!-- Mi material // Datos material -->
        <CourseSessionForm v-if="dialogCourseSession" :session="selectedSession" @closeDialog="closeDialogSessionForm"
            :course="course2" />
    </el-dialog>
    <el-dialog v-model="deleteDialogShown" :title="'¿Desea eliminar esta convocatoria?'" :show-close="false" width="400"
        style="border-radius: 20px;" @confirm="deleteSelectedSession(selectedSession)"
        @close="selectedSession = null; deleteDialogShown = false;"
        @decline="selectedSession = null; deleteDialogShown = false;">
        <div class="row item justify-content-center align-content-center">
            <div class="col-sm-4">
                <button class="btn btn_red" @click="selectedSession = null; deleteDialogShown = false;">
                    Cancelar
                </button>
            </div>
            <div class="col-sm-4">
                <button class="btn btn_yellow" @click="deleteSelectedSession(selectedSession)">
                    Aceptar
                </button>
            </div>
        </div>
    </el-dialog>

</template>

<style lang="scss" scoped>
.btn-search {
    &.btn_yellow {
        color: $bg-blue;
    }

    &.btn_red {
        color: white;
    }

    &.btn_red:disabled {
        background: #F1B3BFB2;
        //opacity: 0.9;
        cursor: not-allowed;
    }

    width: 20em;
    height: 3em;

    font-weight: bolder;
    text-transform: uppercase;
    width: 200px;
    height: 40px;
}

.label-common {
    label {
        font-size: 20px;
        font-weight: 800;
        letter-spacing: -2px;
    }
}

.card-search {
    border-radius: 15px;
    height: 150px;
    background: url("../../assets/icons/altavoz.png"), white;
    background-repeat: no-repeat;
    background-position-x: 100%;
    overflow: visible !important;
}

#icon-search {
    fill: $bg-blue;
    width: 6%;
}

#icon-search-calendar {
    fill: $bg-blue;
    width: 20px;
    height: 20px;
}

.title-text {
    text-align: center;
    align-self: center;
    font-size: 3em;
    font-weight: 900;
    letter-spacing: -0.05em;
    color: $font-blue-color;
}

.table-users {
    table {
        thead {
            tr {
                th {
                    padding: 0px !important;
                    margin: 0px !important;
                }
            }

            #icon-search {
                fill: $bg-blue;
                width: 2.9em;
            }

            #icon-user {
                fill: $bg-blue;
                width: 1.6em;
            }
        }

        tbody {
            td {
                .link-name {
                    margin: auto;
                    margin-left: 10px;
                }
            }
        }
    }
}


.status-active,
.status-inactive {
    display: inline-block;
    padding: 0.35rem 0.75rem;
    border-radius: 0.375rem;
    font-weight: 600;
    font-size: 0.95rem;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
}

.status-active {
    background-color: #27ae60;
}

.status-inactive {
    background-color: #E53935;
}


@media(min-width: 768px) {
    .table-mobile {
        display: none;
    }
}

@media(max-width: 767px) {
    .table-not-mobile {
        display: none;
    }

    .courseFormRow {
        .mt-4 {
            margin-top: 0.5rem !important;
        }
    }


    .courseSessionButton {
        display: flex;
        justify-content: center;

        button {
            margin: 0px 4px 4px !important;
        }
    }

    .filter-options {
        font-size: 20px;
    }

    .card-session-item {
        padding: 10px 0px;
        border-radius: 16px;
        font-size: 15px;

        :deep(.el-card__body) {
            position: relative;
        }

        .session-item-span {
            color: $bg-blue;
            font-weight: 800;
            font-size: 16px;
            line-height: 100%;
            letter-spacing: -5%;

        }
    }

    .session-mobile-card__delete {
        position: absolute;
        top: 10px;
        right: 12px;
        z-index: 1;
    }
}
</style>
